import { useContext } from "react"

import { ThemeContext } from "../../context/themecontext"

import { MoonSVG, SunSVG } from "../../svg"
import styles from "./themeToggle.module.scss"

function ThemeToggle({}) {
  const themeCtx = useContext(ThemeContext)

  function handleToggleTheme() {
    themeCtx.toggleTheme()
  }

  return (
    <>
      <input type="checkbox" hidden checked={themeCtx.value == "light"} onChange={handleToggleTheme} />
      <div onClick={handleToggleTheme} className={styles.toggle}>
        <div className={styles.circle} />
        <div className={styles.sun}>
          <SunSVG />
        </div>
        <div className={styles.moon}>
          <MoonSVG />
        </div>
      </div>
    </>
  )
}

export default ThemeToggle